import * as Sentry from "@sentry/react";
import Cookies from 'js-cookie'

const useSubmitProvidersContactRequest = () => {
    return async (fields, filters, providers, spawnedFrom, recaptchaToken) => {
        const formData = {};
        console.log(providers);
        console.log(document.cookie);
        formData.g_recaptcha = recaptchaToken;

        Object.keys(fields).forEach(key => {
            switch (key) {
                case 'name':
                    if (true) {
                        formData.name = fields[key].value;
                    }
                    break
                case 'organization':
                    if (true) {
                        if (fields[key].touched) {
                            formData.company = fields[key].value;
                        }
                    }
                    break
                case 'phone':
                    if (true) {
                        formData[key] = fields[key].value;
                    }
                    break
                case 'email':
                    if (true) {
                        formData[key] = fields[key].value;
                    }
                    break
                case 'messageBody':
                    if (true) {
                        formData.body = fields[key].value;
                    }
                    break
                default:
                    break
            }
        });

        formData.selected_filters = {
            from: spawnedFrom,
            selected: []
        };

        const providersList = [];

        Object.values(providers).forEach(provider => {
            providersList.push(provider.id);
        });

        formData.providers = providersList;

        const additionalHeaders = {}

        const csrfTokenCookie = Cookies.get('csrftoken')

        if (csrfTokenCookie) {
            additionalHeaders['X-CSRFToken'] = csrfTokenCookie
        }

        // document.cookie.split(';').find((val, index) => {
        //     if (val.includes('csrftoken')) {
        //         additionalHeaders['X-CSRFToken'] = val.split('=')[1]
        //     }
        // })

        console.log(additionalHeaders);
        console.log(JSON.stringify(formData));

        let response;

        try {
            response = await fetch(
                `${process.env.REACT_APP_API_URL}/contactrequest/`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Request-Method': 'POST',
                        ...additionalHeaders
                    },
                    body: JSON.stringify(formData)
                }
            );
        } catch (error) {
            console.log(error);
            Sentry.captureException(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-connection-timeout',
                source: `${error.message}`
            }
            throw error;
        }

        let parsedResponse;
        try {
            parsedResponse = await response.json();
        } catch (error) {
            Sentry.captureException(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-bad-response',
                source: `${response.status} ${response.statusText}`
            }
            throw error;
        }

        if (response.status !== 201) {
            const error = new Error();
            switch (response.status) {
                case 400:
                case 415:
                    Sentry.captureException(parsedResponse);
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.client-bad-request',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
                    break;
                default:
                    Sentry.captureException(parsedResponse);
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.api-bad-response',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
            }
            throw error;
        }

        return parsedResponse;
    }
}

export default useSubmitProvidersContactRequest;
